import React, { useCallback, useEffect, useState } from 'react'
import MonCompteHeader from '../MonCompteHeader'
import './Connexions.css'
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Flux } from '../../../../Models/Message/MessageModels'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import dayjs from 'dayjs';
import CancelIcon from '@mui/icons-material/Cancel';
import { Magasin } from '../../../../Models/Magasin/MagasinModels'
import { URL_MIDIS } from '../../../../Setting'

export function Connexions(props: {
  setInterfaceMonCompte: any
  interfaceMonCompte: number,
  magasins:Magasin[]
}) {

  const [fluxes, setFluxes] = useState<Flux[]>([]);
  const[loading,setLoading]=useState(true);

  const {magasins}=props

  //Automatisation récupération des données
  const infosMagasins = useCallback(async ()=>{
    // if(token){
      const result = magasins.flatMap(mag=>mag.abonnements.flatMap(abo=>abo.fluxes));
      // console.log(result);
      setFluxes(result);
      setLoading(false)
    // }
  },[magasins]);

  const affichageLogoTypeMagFlux = (flux:Flux)=>{
    const typeMag =  magasins.find(mag=>mag.abonnements.find(abo=>abo.fluxes.find(fluxAbo=>fluxAbo['@id']===flux['@id'])))?.typeMagasin;
    if(typeMag && typeMag.fichiers.length>0){
      const url = `${URL_MIDIS+typeMag.fichiers[0].chemin}`;
      return (<img src={url} alt="" style={{width:150}}/>)
    }
    return (
      <></>
    )
  }

  useEffect(()=>{
    if(loading)infosMagasins();//premiere instanciation
    setInterval(()=>{
      infosMagasins();
    }, 1800000);
    return ()=>{}
  },[infosMagasins, loading]);
 

  return (
    <div className='Connexions'>
      <MonCompteHeader
        setInterfaceMonCompte={props.setInterfaceMonCompte}
        interfaceMonCompte={props.interfaceMonCompte}
        mainText='Connexions'
        subText="Suivre l'état de connexion de vos différents point de vente"
      />
      
      <div className='Connexion-main-body'>
        <div className='Connexions-body'>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nom</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Dernière déconnexion</TableCell>
                  <TableCell>Etat connexion</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  fluxes.map((flux,index)=>(
                    <TableRow>
                      <TableCell>{flux.nom}</TableCell>
                      <TableCell>
                        {affichageLogoTypeMagFlux(flux)}
                      </TableCell>
                      <TableCell>{new Date(flux.dateDeconnexion).valueOf()!==0 && dayjs(flux.dateDeconnexion).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                      <TableCell>
                        <IconButton color={new Date(flux.dateDeconnexion).valueOf()===0 ? 'success' : 'error'} edge="end" aria-label="delete">
                          {
                            new Date(flux.dateDeconnexion).valueOf()===0 ? <CheckCircleIcon /> : <CancelIcon/>
                          }
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>

          {/* <List sx={{ width: '90%' }}>
            {
              fluxes.map((flux,index)=>(
                <Fragment key={index}>
                  <ListItem
                    secondaryAction={
                      <IconButton color={new Date(flux.dateDeconnexion).valueOf()===0 ? 'success' : 'error'} edge="end" aria-label="delete">
                        {
                          new Date(flux.dateDeconnexion).valueOf()===0 ? <CheckCircleIcon /> : <CancelIcon/>
                        }
                      </IconButton>
                    }
                  >
                    <ListItemText
                      primary={new Date(flux.dateDeconnexion).valueOf()===0 ? flux.nom : flux.nom+" (Dernière deconnexion : "+dayjs(flux.dateDeconnexion).format('DD/MM/YYYY HH:mm:ss')+")"}
                    >
                    </ListItemText>
                  </ListItem>
                </Fragment>
              ))
            }
          </List> */}
        </div>
      </div>
    </div>
  )
}